<template>
  <div>
    <h1 class="show-in-mobile">Configuración</h1>
    <el-form :model="form" ref="form">
      <el-tabs type="border-card" v-loading="loading" 
      element-loading-text="Cargando...">
        <el-tab-pane label="Sólido">
          <el-row>
            <p style="margin-top: 0px;">Precio</p>
            <el-col :xs="24" :md="24" style="margin-bottom: 10px;">
              <el-form-item prop="price_solid_drum">
                <el-input v-model="form.solid.price.drum" autocomplete="off" style="width: 70px; margin-right:10px"></el-input>
                <span>($) por Tambor</span>
              </el-form-item>
            </el-col>
            <p>Cantidad máxima por camión</p>
            <el-col :xs="24" :md="24" style="margin-bottom: 10px;">
              <el-form-item prop="price_solid_drum">
                <el-input v-model="form.solid.quantity.drum" autocomplete="off" style="width: 70px; margin-right:10px"></el-input>
                <span>Tambores</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="Barro">
          <el-row>
            <p style="margin-top: 0px;">Precio</p>
            <el-col :xs="24" :md="12" style="text-align:left">
              <el-form-item prop="price_mud_drum">
                <el-input v-model="form.mud.price.drum" autocomplete="off" style="width: 70px; margin-right:10px"></el-input>
                <span>($) por Tambor</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" style="margin-bottom: 10px;">
              <el-form-item prop="price_mud_m3">
                <el-input v-model="form.mud.price.m3" autocomplete="off" style="width: 70px; margin-right:10px"></el-input>
                <span>($) por m3 (Granel)</span>
              </el-form-item>
            </el-col>
            <p>Cantidad máxima por camión</p>
            <el-col :xs="24" :md="12" style="text-align:left">
              <el-form-item prop="price_mud_drum">
                <el-input v-model="form.mud.quantity.drum" autocomplete="off" style="width: 70px; margin-right:10px"></el-input>
                <span>Tambores</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" style="margin-bottom: 10px;">
              <el-form-item prop="price_mud_m3">
                <el-input v-model="form.mud.quantity.m3" autocomplete="off" style="width: 70px; margin-right:10px"></el-input>
                <span>m3 (Granel)</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="Agua">
          <el-row>
            <p style="margin-top: 0px;">Precio</p>
            <el-col :xs="24" :md="12">
              <el-form-item prop="price_water_drum">
                <el-input v-model="form.water.price.drum" autocomplete="off" style="width: 70px; margin-right:10px"></el-input>
                <span>($) por Tambor</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" style="margin-bottom: 10px;">
              <el-form-item prop="price_water_m3">
                <el-input v-model="form.water.price.m3" autocomplete="off" style="width: 70px; margin-right:10px"></el-input>
                <span>($) por m3 (Granel)</span>
              </el-form-item>
            </el-col>
            <p>Cantidad máxima por camión</p>
            <el-col :xs="24" :md="12">
              <el-form-item prop="price_water_drum">
                <el-input v-model="form.water.quantity.drum" autocomplete="off" style="width: 70px; margin-right:10px"></el-input>
                <span>Tambores</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" style="margin-bottom: 10px;">
              <el-form-item prop="price_water_m3">
                <el-input v-model="form.water.quantity.m3" autocomplete="off" style="width: 70px; margin-right:10px"></el-input>
                <span>m3 (Granel)</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="Aceite">
          <el-row>
            <p style="margin-top: 0px;">Precio</p>
            <el-col :xs="24" :md="24" style="margin-bottom: 10px;">
              <el-form-item prop="price_oil_drum">
                <el-input v-model="form.oil.price.drum" autocomplete="off" style="width: 70px; margin-right:10px"></el-input>
                <span>($) por Tambor</span>
              </el-form-item>
            </el-col>
            <p>Cantidad máxima por camión</p>
            <el-col :xs="24" :md="24" style="margin-bottom: 10px;">
              <el-form-item prop="price_oil_drum">
                <el-input v-model="form.oil.quantity.drum" autocomplete="off" style="width: 70px; margin-right:10px"></el-input>
                <span>Tambores</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <el-button
      v-if="hasPermission('edit')"
      :loading="loadingSaveButton"
      type="primary"
      @click="handleSaveButton('form')"
      size="medium"
      style="margin-top: 20px"
    >Guardar</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loadingSaveButton: false,
      form: {
        mud: {
          price: {
            drum: 0,
            m3: 0
          },
          quantity: {
            drum: 0,
            m3: 0
          }
        },
        water: {
          price: {
            drum: 0,
            m3: 0
          },
          quantity: {
            drum: 0,
            m3: 0
          }
        },
        solid: {
          price: {
            drum: 0,
          },
          quantity: {
            drum: 0,
          }
        },
        oil: {
          price: {
            drum: 0,
          },
          quantity: {
            drum: 0,
          }
        },
      },
      formLabelWidth: '120px',
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    this.$store.commit("CHANGE_SECTION", { name: "Configuración", index: "6" });

    // Load config
    await this.$store.dispatch("getConfig");
    this.form = await this.$store.state.config.config
    this.loading = false;
  },
  methods: {
    hasPermission( permissionReq ) {
      return this.$store.getters.hasPermission('Config', permissionReq)
    },
    handleSaveButton(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          // Valid form
          this.loadingSaveButton = true
          await this.$store.dispatch("updateConfig", this.form)
          .then(() => {
            this.$message({
              type: "success",
              message: 'La configuración se guardó correctamente'
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              showClose: true,
              duration: 0,
              message: 'Hubo un error guardando la configuración. Recargue la página'
            });
          })
          this.loadingSaveButton = false
        }
      })
    }
  },
  computed: {
    is_mobile() {
      return this.$store.state.is_mobile;
    },
    activities() {
      return this.$store.state.users.activities
    }
  }
};
</script>

<style scoped>
.el-form-item__label {
  font-weight: 600 !important;
}

.el-tabs--border-card > .el-tabs__header {
  border-radius: 5px 5px 0px 0px !important;
}

.el-tabs--border-card {
  box-shadow: none;
  border-radius: 5px !important;
  text-align: left !important;
}

.el-tabs__nav-wrap {
  border-radius: 5px;
}

.el-row {
  margin-top: 20px;
  margin-left: 15px;
}
</style>